const getCashbackStatusColors = (status) => {
  switch (status) {
    case 'created':
      return '#b0b3b8'
    case 'available':
      return '#2d87d9'
    case 'pending':
      return '#f8c233'
    case 'paid':
      return '#217869'
    case 'declined':
      return '#cf485a'
    case 'expired':
      return '#495e6b'
    default:
      return ''
  }
}

export { getCashbackStatusColors }
